import * as React from "react";
import './LendioWelcome.css';

import {Redirect, RouteComponentProps} from "react-router-dom";
import FormButton from "../../../../../components/FormButton/FormButton";
import {formStores} from "../../../state/mobx";
import {LendioState} from "../../../state/LendioState";
import {observer} from "mobx-react";
import FormPayment from "../../SignUpForm/FormPayment/FormPayment";
import FormVerification from "../../SignUpForm/FormVerification/FormVerification";
import FormFinish from "../../SignUpForm/FormFinish/FormFinish";
import Loader from "../../../../../components/Loader/Loader";
import NavigationConstants from "../../../../Navigation/NavigationConstants";
import FormFinancialContainer from "../../SignUpForm/FormFinancial/FormFinancialContainer";
import FormBankSelectionContainer from "../../SignUpForm/FormBankSelection/FormBankSelectionContainer";
interface IProps extends RouteComponentProps<any> {

}

const store = formStores.shortSignupStore;

@observer
export default class LendioWelcome  extends React.Component<
    IProps
    > {

    public next = () => {
        store.updateCurrentComponent(LendioState.financial);
    };

    public renderLoanAmount = () => {
        return store.isLoading? <Loader/> : "$ " + store.formInput.financial.amount
    }

    public renderComponent = () => {
        if(store.navigateTo404) {
            return <Redirect to={NavigationConstants.notFound404} />
        }
        else if(store.navigateToExpiredOffer) {
            return <Redirect to={NavigationConstants.offerExpired} />
        }
        switch (store.currentComponent) {
            case LendioState.welcome:
                    return (
                        <>
                            <div className="lendio-welcome-container">
                                <div className="lendio-header">Thank you for choosing Salaryo</div>
                                <div className="lendio-sub-header">Please complete your business loan application here:</div>
                                <div className="lendio-amount">{this.renderLoanAmount()}</div>
                                <FormButton classes={"yellow"} click={this.next} btnText={'Get started'}/>
                            </div>
                        </>
                    );
            case LendioState.financial: return  <FormFinancialContainer isAmountLocked={true} store={store}/>;
            case LendioState.bankSelection: return <FormBankSelectionContainer store={store}/>
            case LendioState.payment: return <FormPayment store={store} {...this.props}/>;
            case LendioState.verification: return <FormVerification isLendio={true} store={store}/>;
            case LendioState.thankYou: return <FormFinish {...this.props} store={store}/>;
            default: return null;
        }
    };

    public render() {
        return (<>{this.renderComponent()}</>);
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormLendio/LendioWelcome/LendioWelcome.tsx